<template>
  <div class="wrapCon">
    <el-button @click="back" type="danger" icon="el-icon-d-arrow-left">返回</el-button>
    <!-- <span class="backTxt" @click="back">>>>返回</span> -->
    <div class="topVS flexBetween">
      <div class="left">{{ policyName }}</div>
      <div><span class="letterV">V</span><span class="letterS">S</span></div>
      <div class="right">{{ cpu_enterprise }}</div>
    </div>
    <div>
      <div class="resultTxt">匹配结果</div>
      <div>
        <el-table :data="tableData" style="width: 100%;" header-align="center">
          <el-table-column type="index" align="center" label="序号" width="80">
          </el-table-column>
          <el-table-column prop="request" align="left" label="政策指标要求">
          </el-table-column>
          <el-table-column prop="qysx" align="center" label="企业属性" width="200"> </el-table-column>
          <el-table-column prop="isMatch" align="center" label="是否匹配" width="200">
            <template slot-scope="scope">
              <!-- 支持匹配 -->
              <i
                class="el-icon-circle-check"
                style="color: #aedbff"
                v-show="scope.row.isMatch == 'yes'"
              ></i>
              <div v-show="scope.row.isMatch== 'no'">
                <i class="el-icon-circle-close" style="color: #ff3b3a"></i>
                <a href="https://12366.chinatax.gov.cn/xiaohui/" target="_blank">在线咨询</a>
              </div>
              <!-- <span>{{ scope.row.isMatch }}</span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <!-- 饼状图 -->
        <el-row :gutter="10">
          <el-col :span="12" :offset="8">
            <div id="stat1" :style="{ width: '300px', height: '300px' }"></div>
          </el-col>
        </el-row>
        <div style="width:100%;display:flex;justify-content:center;margin-bottom:20px"><el-button type="danger" @click="openZxzx">政策咨询</el-button></div>
      </div>

    </div>
  </div>
</template>

<script>
import echarts from "echarts";
// import { option1, option2 } from "../echartsData/data";
import { mapGetters } from "vuex";
// const option1 = ;
export default {
  components: {},
  props: {
    policyName: {
      type: String,
    },
    enterprise: {
      type: String,
    },
    showForm: {
      type: Array,
    },
    percentage: {
      type: String || Number,
    },
    answerData: {
      type: Array,
    },
    isMatchData:{
      type: Array,
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      getDictList: "dictionary/getDictList",
      getDictLabel: "dictionary/getDictLabel",
    }),
    cpu_enterprise() {
      if (!this.userInfo) return "";
      return this.userInfo?.enterpriseInfo?.enterprise || "";
    },
  },
  data() {
    return {
      // option1,
      // option2,
      tableData: [],
      // percentage:0.17,
    };
  },
  created() {
    this.getTabelData();
  },
  mounted() {
    let chart1 = echarts.init(document.getElementById("stat1"));
    chart1.setOption(
      {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        color: ["#ff0000", "#009dff"],
        legend: {
          orient: "vertical",
          right: 0,
          top: 50,
          data: ["已匹配", "未匹配"],
        },
        series: [
          {
            name: "匹配度",
            type: "pie",
            radius: "55%",
            center: ["35%", "45%"],
            label: {
              show: false,
              position: "left",
            },
            data: [
              { value: this.percentage, name: "已匹配" },
              { value: 1 - this.percentage, name: "未匹配" },
            ],
          },
        ],
      },
      true
    );
  },
  methods: {
    openZxzx(){
      this.$emit("backEventTwo","PolicyConsult")
    },
    back(){
      this.$emit("backEvent","accurateMatch")
    },
    getTabelData() {
      let that = this;
      that.tableData = [];
      that.showForm.forEach((item, index) => {
        that.tableData.push({
          request: item.sqPolicyProblem.name,//指标要求
        });
      });
      that.answerData.forEach((item, index) => {
        that.tableData[index]["qysx"] = item;//企业属性
      });
      that.isMatchData.forEach((item, index) => {
        that.tableData[index]["isMatch"] = item;//是否匹配
      });
    },
  },
};
</script>

<style lang='scss' scoped>
$width: 1150px;
.flexBetween {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.wrapCon {
  width: $width;
  margin: 0 auto;
  font-size: 18px;
  .backTxt {
    display: inline-block;
    cursor:pointer;
    font-size:18px;
    cursor: pointer;
    font-size: 18px;
    color: #e0ecfa;
    padding-top: 15px;
  }
  .topVS {
    padding-bottom: 10px;
    margin-top: 20px;
    border-bottom: 1px dashed #d71517;
    color: #fff;
    font-size: 18px;
    .left,
    .right {
      width: 47%;
      height: 120px;
      padding: 10px;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .left {
      background: linear-gradient(to right, #2471fb, #e26df7) left top no-repeat;
    }
    .right {
      background: linear-gradient(to right, #ff565e, #ff8a49) left top no-repeat;
    }
    .letterV {
      color: #e26df7;
    }
    .letterS {
      color: #ff565e;
    }
  }
  .resultTxt {
    width: 100%;
    height: 40px;
    background: #ff8a49;
    text-align: center;
    line-height: 40px;
    color: #fff;
    margin: 20px auto;
  }
}
::v-deep .el-table tr {
  font-size: 18px;
  color: #333;
}
</style>
